import { MedSolInput, IMedSolInputProps } from '@ms/medsol-components';

interface INumberInputProps extends Omit<IMedSolInputProps, 'inputType'> {}

export function NumberInput({ ...rest }: INumberInputProps) {
    return <MedSolInput type="number" {...rest} />;
}
